/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_23ed9fbc"]'><div><cube-button @_click="show">top/right/bottom-top-transition</cube-button><cube-popup ref="__mpx_ref_popup__" :position="(pos)" :maskClosable="(true)" :maskFadeTransition="(true)" :transition="(trans)" :class='["cube-extend-popup"]'><div :class='["popup-slot"]'>This is transition popup</div></cube-popup></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_23ed9fbc"}'>
.cube-extend-popup
  .cube-popup-content
    padding: 20px
    color: #fff
    background-color: rgba(0, 0, 0, .8)
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_23ed9fbc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_23ed9fbc"}
  /** script content **/
  require("./popup-transition.mpx.js?isComponent&outputPath=components%2Fpopup-transition23ed9fbc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./popup-transition.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fpopup-transition23ed9fbc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_23ed9fbc"],
    ctorType: "component",
    outputPath: "components/popup-transition23ed9fbc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>